module.exports = __webpack_public_path__ + "static/media/direct-mail.80c1157c.svg";